import { createSvgIcon } from './IconUtils';

export const CheckIconBold = createSvgIcon(
  'CheckIconBold',
  <>
    <path
      fill="currentColor"
      d="M7.57 12.89 4.41 9.78l-1.077 1.052L7.572 15l9.096-8.949L15.598 5z"
    />
    <path
      fill="currentColor"
      d="m4.41 9.78 3.16 3.11L15.599 5l1.069 1.051L7.57 15l-4.238-4.168zm3.16 2.525 8.028-7.89 1.663 1.636-9.69 9.534-4.833-4.755 1.673-1.633z"
    />
  </>,
  {
    viewBox: '0 0 20 20',
  },
);
